import { actions } from 'data'
import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { useParams } from 'react-router-dom'

// Clicked email link to activate newly setup API key
const ApiKeyActivation = () => {
  const dispatch = useDispatch()
  const { id } = useParams()

  useEffect(() => {
    if (!id) return
    dispatch(actions.apiKey.activate(id))
  }, [])

  return null
}

export default ApiKeyActivation
